import type { PropsWithChildren } from "react";

import { WithMondayContextAvailable } from "./WithMondayContextAvailable";
import { WithMondayTheme } from "./WithMondayTheme";
import { WithOAuthEnabled } from "./WithOAuthEnabled";
import { WithValidLicense } from "./WithValidLicense";

export function WithContexts({ children }: PropsWithChildren) {
  return (
    <WithMondayContextAvailable>
      <WithMondayTheme>
        <WithValidLicense>
          <WithOAuthEnabled>{children}</WithOAuthEnabled>
        </WithValidLicense>
      </WithMondayTheme>
    </WithMondayContextAvailable>
  );
}
